import { cn } from "@/lib/utils";

/**
 * BATCH · *Cooking* wordmark. Serif, wide tracking, italic right half.
 */
export function Wordmark({
  size = "md",
  className,
  as: As = "div",
}: {
  size?: "sm" | "md" | "lg";
  className?: string;
  as?: "div" | "span" | "h1";
}) {
  const sizeClass = {
    sm: "text-[11px]",
    md: "text-[14px]",
    lg: "text-[22px]",
  }[size];
  return (
    <As
      className={cn(
        "font-serif font-medium uppercase tracking-[0.16em] text-foreground",
        sizeClass,
        className,
      )}
    >
      Batch&nbsp;·&nbsp;<span className="font-normal italic">Cooking</span>
    </As>
  );
}
